import { getRegeneronFormInitialValues } from "../../initialValuesUtils";

export const getRegeneronPapFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getRegeneronFormInitialValues({ applicationForm, formJson });
  return initialValues;
};
